module.exports = __webpack_public_path__ + "static/media/user-purple.344282c9.svg";